import { defineStore } from 'pinia';

export const useModalStore = defineStore('modal', {
    state: () => ({
        SignIn: false,
        SignUp: false,
        ResetPassword: false,
        Subscribe: false,
        scrollY: 0,
    }),
    actions: {
        toggleModal(popupId: string, popupState: any) {
            this.SignIn = false;
            this.SignUp = false;
            this.ResetPassword = false;
            this.Subscribe = false;
            (this as any)[popupId] = popupState;
            if (popupState) {
                this.disableScroll();
            } else {
                this.enableScroll();
            }
        },
        disableScroll() {
            this.scrollY = window.scrollY;
            document.body.style.overflow = 'hidden';
            // overflow hidden is not enough on IOS safari
            document.body.style.position = 'fixed';
            document.body.style.top = `-${this.scrollY}px`;
            document.body.style.left = '0';
            document.body.style.right = '0';
        },
        enableScroll() {
            document.body.style.overflow = '';
            document.body.style.position = '';
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.left = '';
            document.body.style.right = '';
            requestAnimationFrame(() => {
                window.scrollTo({ top: this.scrollY, behavior: 'instant' });
            });
        },
    },
});
